import React, { FunctionComponent } from 'react'
import {
  ButtonLink,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'

export const OfflineModal: FunctionComponent = () => {
  return (
    <Modal focusTrapActive={false}>
      <ModalHeader>
        <T _str="You can’t access this content while offline" />
      </ModalHeader>
      <ModalContent>
        <T _str="You’ll be able to access this again when you’re online. Meanwhile you can continue to make sales on the Sell Screen." />
      </ModalContent>
      <ModalActions>
        <ButtonLink type="go" href="/webregister/">
          <T _str="Go to the Sell Screen" />
        </ButtonLink>
      </ModalActions>
    </Modal>
  )
}
